import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import {ActivityLogAPI} from "./../../API/Admin/UserAPI";
import Sidebar from "./Common/Sidebar";
import Header from "./Common/Header";
import Loader from "./../Loader";
import Paginate from "./../../utils/Pagination";


const ActivityLogs = () =>{

    const [activitylogList, setActivityLogList] = useState([]);
    const [logcount, setLogCount] = useState(0);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);

    const perpagedata = 15;

    useEffect(() => {

        ActivityLogAPI(setActivityLogList, setLogCount, setLoading, currentPage, perpagedata, setPageCount);

        //console.log('>>>>'+activitylogList);

    }, [currentPage]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }

    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">

                <div className="row">
                    <div className="col-md-12">

                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-8">
                                    <h4 className="page-title">Activity Logs List</h4>
                                </div>
                                <div className="col-4 text-end">
                                    <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end">
                                        <div className="form-sorts dropdown me-2">
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card">

                            <div className="card-body">

                                <div className="table-responsive custom-table">
                                    
                                    <table className="table" id="faqlist">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>User Type</th>
                                                <th>Name</th>
                                                <th>IP</th>
                                                <th>Activity</th>                                                
                                                <th>Created On</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                    
                                        {loading ?
                                            <tr>
                                                <td colSpan="5">
                                                    <Loader />
                                                </td>
                                            </tr>
                                        :
                                            (activitylogList && activitylogList.length > 0  ? 
                                                ( activitylogList.map(activitylog => 
                                                    (
                                            
                                                        <tr key={activitylog.id}>
                                                            <td>
                                                                {activitylog.role_id === 2 ?
                                                                    <span>Sales</span>
                                                                :
                                                                    (activitylog.role_id === 3 ?
                                                                        <span>Caller</span>
                                                                    :
                                                                        (activitylog.role_id === 4 ?
                                                                            <span>Team Lead</span>
                                                                        :
                                                                            <span>-</span>
                                                                        )
                                                                    )
                                                                }
                                                            </td>
                                                            <td>{activitylog.name}</td>
                                                            <td>{activitylog.ip}</td>
                                                            <td>{activitylog.action}</td>
                                                            
                                                            <td>{moment(activitylog.created_at).format('DD-MMM-YYYY h:mm:ss')}</td>
                                                        </tr>
                                                    )
                                                ))
                                            
                                            :
                                        
                                                <tr>
                                                    <td colSpan="5">
                                                        <center>No record found...</center>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    
                                        </tbody>
                                    </table>
                                    
                                </div>
                                

                            </div>
                        </div>
                        
                        { pagecount > 1 ?
                        <div className="row pagination-section">
                            <nav>
                                <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                            </nav>
                        </div>
                        :
                            <></>
                        }

                    </div>
                </div>

            </div>
        </div>
    </div>
    )
}

export default ActivityLogs;